import { render, staticRenderFns } from "./AsignacionFiltroPlataforma.vue?vue&type=template&id=962c1a98&"
import script from "./AsignacionFiltroPlataforma.vue?vue&type=script&lang=ts&"
export * from "./AsignacionFiltroPlataforma.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('962c1a98', component.options)
    } else {
      api.reload('962c1a98', component.options)
    }
    module.hot.accept("./AsignacionFiltroPlataforma.vue?vue&type=template&id=962c1a98&", function () {
      api.rerender('962c1a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/AsignacionFiltroPlataforma.vue"
export default component.exports